import PATH from "constants/path";
import React from "react";
import routes from "./routes";
import {
  Switch,
  Route,
  withRouter,
  useLocation,
  useHistory,
} from "react-router-dom";
import { returnCommom, clearLocalStorage, isAuthenticated } from "utils/common";
import { Layout, PrivateRoute, PublicRoute } from "./components";
import { STATUS_CODES, SERVICE } from "constants/global";
import PageNotFound from "views/PageNotFound";
import SorryPage from "views/SorryPage";

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const pathname = location.pathname;
  const search = location.search;
  const isHash = location.hash;

  // param URL
  const queryParams = new URLSearchParams(search);
  const token = new URLSearchParams(search).get("token");
  const expires_date = new URLSearchParams(search).get("expires_date");

  if (token && expires_date) {
    // save token info to localstorage
    localStorage.setItem(
      "AUTH",
      JSON.stringify({
        access_token: token,
        expires_date,
      })
    );

    // clear params in URL
    queryParams.delete("token");
    queryParams.delete("expires_date");

    history.replace({
      search: queryParams.toString(),
    });
  }

  // click URL auto entry
  if (pathname.includes("/promotion/view/") && token) {
    if (isAuthenticated()) {
      clearLocalStorage();
    }
    // return COMMON call API auto apply
    window.location = `${
      PATH.COMMON
    }?service=${SERVICE}&auto_apply=${encodeURIComponent(
      window.location.href
    )}`;

    return null;
  }

  // check expired token
  const authStore = localStorage.getItem("AUTH");
  let authParse = "";

  if (authStore) {
    try {
      authParse = JSON.parse(authStore);
      let expiresDate = new Date(authParse.expires_date);
      let todaysDate = new Date();

      // check expired
      if (todaysDate > expiresDate) {
        clearLocalStorage();
        // quay về COMMON check token
        returnCommom();
        return null;
      }
    } catch (error) {
      clearLocalStorage();
    }
  }

  const hashValue = isHash?.split("#")?.[1];

  return (
    <Layout>
      <Switch>
        {hashValue === 'sorry' ? (
          <Route path="*" component={SorryPage} />
        ) : Object.values(STATUS_CODES).includes(hashValue) ? (
          <Route path="*" component={PageNotFound} />
        ) : (
          routes.map((prop, key) => {
            // check route
            return prop?.private === true ? (
              <PrivateRoute
                path={prop.path}
                key={key}
                component={prop.component}
                {...prop}
              />
            ) : prop?.private === false ? (
              <PublicRoute
                path={prop.path}
                key={key}
                component={prop.component}
                {...prop}
              />
            ) : (
              <Route
                path={prop.path}
                key={key}
                component={prop.component}
                {...prop}
              />
            );
          })
        )}
      </Switch>
    </Layout>
  );
};

export default withRouter(App);
